<template>

	<div style="height: 100%;width: 100%;display:inline-block;">

        <!-- 卡片试图区域 -->
        <el-card>
			<div slot="header" class="clearfix">
					  <span>界面管理</span>
					</div>
          <!-- 搜索与添加区域 -->
        	<el-row :gutter="20">
        			<el-col :span="4">
        				<el-button type="primary" @click="openAdd" >添加信息</el-button>
        				</el-col>
        	</el-row>
        	<!-- 菜单列表区域 -->
        	 <el-table
        	    :data="list"
        		  border
        		  stripe
        		  row-key="id"
        		  border
        		  default-expand-all
        		  :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        			  >
        		  <el-table-column
        		    type="index"
        		   >
        		  </el-table-column>
        	      <el-table-column
        	        prop="name"
        	        label="名称">
        	      </el-table-column>
        		  <el-table-column
        		    prop="description"
        		    label="描述">
        		  </el-table-column>
        		  <el-table-column label="图片">
        		  <template slot-scope="scope">
        		  <img :src="scope.row.img_url" v-if="scope.row.img_url !=1" width="100px" height="100px" />
        		  <img  src="../../assets/img/covernull.png" width="100px" height="100px" v-else/>
        		  </template>
        		  </el-table-column>
              <el-table-column
                prop="size"
                label="展示图片大小">
                <template slot-scope="scope">
                	 {{scope.row.size === "B"?"大图":"小图"}}
                </template>
              </el-table-column>
              <el-table-column
                prop="create_time"
                label="创建时间">
                <template slot-scope="scope">
                	 {{scope.row.create_time | fmtdate}}
                </template>
              </el-table-column>
        		  <el-table-column
        		    label="操作">
        			<template slot-scope="scope">
        				<el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
        				 	<el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button>
        				   </el-tooltip>
        				<el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
        				 	<el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.id)"></el-button>
        				   </el-tooltip>
        				</template>
        		  </el-table-column>
        	    </el-table>
        </el-card>
        <!-- 添加对话框 -->
        <el-dialog
          title="添加信息"
          :visible.sync="addDialogVisible"
          width="50%"
          @close="addDialogClosed"
        >
        <el-alert
            title="一级权限等级的信息,名称和父级名称和权限等级这三项需要认真填!"
            type="warning"
            show-icon
        		  :closable="false"
        		  style="margin-bottom: 15px;"
        		  >
          </el-alert>
          <!-- 内容主体区域 -->
         <el-form
         :rules="addFormRules"
         ref="addFormRef"
         :model="addForm"
         label-width="110px">
           <el-form-item label="名称" prop="name">
             <el-input v-model="addForm.name"></el-input>
           </el-form-item>
           <el-form-item label="描述" prop="description">
             <el-input v-model="addForm.description"></el-input>
           </el-form-item>
           <el-form-item label="父级名称" prop="Fid" >
           		   <el-select v-model="addForm.Fid" placeholder="请选择父级名称" style="width: 100%;" @change="choose">
           		       <el-option
           		         v-for="item in fidlist"
           		         :key="item.id"
           		         :label="item.name"
           		         :value="item.id"
           				 >
           		       </el-option>
           		     </el-select>
           </el-form-item>
           <el-form-item label="权限等级" prop="type">
        	   <el-select v-model="addForm.type" placeholder="请选择权限等级" style="width: 100%;">
        	       <el-option
        	         v-for="item in Rightlist"
        	         :key="item.typeId"
        	         :label="item.label"
        	         :value="item.typeId">
        	       </el-option>
        	     </el-select>
           </el-form-item>
           <el-form-item label="展示图片大小" prop="size">
             <el-select v-model="addForm.size" placeholder="请选择" style="width: 100%;">
                 <el-option
                   v-for="item in sizeList"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                 </el-option>
               </el-select>
           </el-form-item>
           <el-form-item label="图片" prop="img_url">
           							<!-- 用来显示图片 -->
           							  <img
           							  src="../../assets/img/coverimg.png"
           							  alt=""
           							  ref='imgRef'
           							  width="400px"
           							  height="400px"
           							  />
           							  <br />
           							<!-- 文件选择框，默认被隐藏 -->
           							 <input
           							 type='file'
           							 style="display:none"
           							 accept='image/*'
           							 ref='iptFileRef'
           							 @change="changeCoverFn"
           							 />
           							 <!-- 选择封面的按钮 -->
           							 <el-button type="primary" @click="selCoverFn">选择图片</el-button>
           							 <!-- 删除图片 -->
           							 <el-button type="danger" @click="delCoverFn">删除图片</el-button>
           						</el-form-item>
           </el-form>
          <!-- 底部区域 -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addFn">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 修改菜单的对话框 -->
        <el-dialog
          title="修改信息"
          :visible.sync="editDialogVisible"
          width="50%"
          @close="editDialogClosed"
        >
          <!-- 内容主体区域 -->
         <el-form
         :rules="editFormRules"
         ref="editFormRef"
         :model="editForm"
         label-width="110px">
           <el-form-item label="名称" prop="name">
             <el-input v-model="editForm.name"></el-input>
           </el-form-item>
           <el-form-item label="描述" prop="description">
             <el-input v-model="editForm.description"></el-input>
           </el-form-item>
           <el-form-item label="父级名称" prop="Fid" >
           		   <el-select v-model="editForm.Fid" placeholder="请选择父级名称" style="width: 100%;" @change="editchoose">
           		       <el-option
           		         v-for="item in fidlist"
           		         :key="item.id"
           		         :label="item.name"
           		         :value="item.id"
           				 >
           		       </el-option>
           		     </el-select>
           </el-form-item>
           <el-form-item label="权限等级" prop="type">
             <el-select v-model="editForm.type" placeholder="请选择权限等级" style="width: 100%;">
                 <el-option
                   v-for="item in Rightlist"
                   :key="item.typeId"
                   :label="item.label"
                   :value="item.typeId">
                 </el-option>
               </el-select>
           </el-form-item>
           <el-form-item label="展示图片大小" prop="size">
             <el-select v-model="editForm.size" placeholder="请选择" style="width: 100%;">
                 <el-option
                   v-for="item in sizeList"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                 </el-option>
               </el-select>
           </el-form-item>
          <el-form-item label="图片" prop="img_url">
          							<div class="spec-preview">
          							<img :src="this.editTp"  alt="" ref='editimgRef' v-if='this.editTp !=1'/>
          							<img src="../../assets/img/covernull.png"  alt="" ref='editimgRef' v-else/>
          								<div class="event" @mousemove="handler"></div>
          									 <div class="big">
          										<img :src="this.editTp" alt="" ref='big' v-if='this.editTp !=1'/>
          										<img src="../../assets/img/covernull.png" alt="" ref='big'  v-else/>
          								     </div>
          										<!-- 遮罩层 -->
          								<div class="mask" ref="mask"></div>
          								</div>
          								<br/>
          						<!-- 文件选择框，默认被隐藏 -->
          							         <input
          								   		 type='file'
          								   		 style="display:none"
          								   		 accept='image/*'
          								   		 ref='editiptFileRef'
          								   		 @change="editchangeCoverFn"
          								   		 />
          										 <el-button type="primary" @click="editselCoverFn">选择图片</el-button>
          						</el-form-item>
           </el-form>
          <!-- 底部区域 -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="editInfo">确 定</el-button>
          </span>
        </el-dialog>


		</div>
</template>

<script>
  //标签和样式钟，引入图片文件可以写路径，在js里引入图片文件要import引入
  //webpack会把图片变成为一个base64字符串/在打包后的图片临时地址
  import imgObj from '../../assets/img/coverimg.png'
	export default{
		data(){
			return{
				list:[],
				//获取父级名称
				fidlist:[],
				//获取权限等级
				Rightlist:[],
        //展示图片大小
        sizeList:[
                 {
                    value: 'B',
                    label: '大图'
                  }, {
                    value: 'S',
                    label: '小图'
                  }
        ],
				//控制添加对话框的显示与隐藏
				addDialogVisible:false,
				//控制修改对话框的显示与隐藏
				editDialogVisible:false,
				addForm:{
					name:'',
					description:'',
					Fid:'',
					type:'',
					img_url:'',
          size:''
				},
                //添加表单的验证规则对象
				addFormRules:{
					name:[
						{required:true,message:'请输入名称',trigger:'blur'},
						{min:2,max:20,message:'名称的长度在2~20字符之间',trigger:'blur'}
					],
					Fid:[
						{required:true,message:'请选择父级名称',trigger:'change'},
					],
          type:[
						{required:true,message:'请选择权限等级',trigger:'change'},
					],
          img_url:[
          	{required:true,message:'请选择图片',trigger:'change'},
          ],
          size:[
          	{required:true,message:'请选择图片大小',trigger:'change'},
          ],
				},
				//修改信息对象
				editForm:{},
        //回显图片
        editTp: '',
				//修改表单的验证规则对象
				editFormRules:{
					name:[
						{required:true,message:'请输入名称',trigger:'blur'},
						{min:2,max:20,message:'名称的长度在2~20字符之间',trigger:'blur'}
					],
					Fid:[
						{required:true,message:'请选择父级名称',trigger:'change'},
					],
					type:[
						{required:true,message:'请选择权限等级',trigger:'change'},
					],
					img_url:[
						{required:true,message:'请选择图片',trigger:'change'},
					],
          size:[
          	{required:true,message:'请选择图片大小',trigger:'change'},
          ],
				},
			}
		},
		created(){
			this.getHomeList()
		},
		methods:{
      //放大镜----------------
      handler(event) {
      	let mask = this.$refs.mask;
      	let big = this.$refs.big;
      	let left = event.offsetX - mask.offsetWidth / 2;
      	let top = event.offsetY - mask.offsetHeight / 2;
      	//约束范围
      	if (left <= 0) {
      		left = 0
      	}
      	if (left >= mask.offsetWidth) {
      		left = mask.offsetWidth
      	}
      	if (top <= 0) {
      		top = 0
      	}
      	if (top >= mask.offsetHeight) {
      		top = mask.offsetHeight
      	}
      	//修改元素left、top属性值
      	mask.style.left = left + 'px';
      	mask.style.top = top + 'px';
      	big.style.left = -2 * left + 'px'
      	big.style.top = -2 * top + 'px'
      },
			async getHomeList(){
				const {data:res} = await this.$http.getHomeList()
				if (res.status !==0){
	             return this.$message.error('获取首页信息失败!')
				}
				this.list = res.data
				//过滤数组
				const options_one = res.dataList.filter(item=>{
						return item.type < 2
					})
				const options_two =[{id:0,name: '添加没有父级名称'}]
					//使用ES6扩展运算符…合并
					let arry = [
						...options_two,
						...options_one
					]
				this.fidlist = arry
			},
      choose(val){
      	//VUE页面中下拉框（el-select）的change事件选中获取整个对象数据
      	var obj = {}
      	obj = this.fidlist.find(function(i){
      		return i.id === val
      	})
      	//联动等级下拉框
      	if(obj.type==undefined){
      		this.Rightlist=[]
          this.addForm.type = ''
      		this.Rightlist.push({
      		   typeId: 1,
      		   label: '一级权限'
      		})
      	}else if(obj.type== 1){
      		 this.Rightlist=[]
           this.addForm.type = ''
      		 this.Rightlist.push({
      		    typeId: 2,
      		    label: '二级权限'
      		 })
      	}
      },
      editchoose(val){
      	//VUE页面中下拉框（el-select）的change事件选中获取整个对象数据
      	var obj = {}
      	obj = this.fidlist.find(function(i){
      		return i.id === val
      	})
      	//联动等级下拉框
      	if(obj.type==undefined){
      		this.Rightlist=[]
      	  this.editForm.type = ''
      		this.Rightlist.push({
      		   typeId: 1,
      		   label: '一级权限'
      		})
      	}else if(obj.type== 1){
      		 this.Rightlist=[]
      	   this.editForm.type = ''
      		 this.Rightlist.push({
      		    typeId: 2,
      		    label: '二级权限'
      		 })
      	}
      },
			openAdd(){
				this.addDialogVisible = true
			},
      /*图片处理*/
      //让文件选择窗口出现
      selCoverFn() {
      	this.$refs.iptFileRef.click()
      },
      changeCoverFn(e) {
      	//e.target.files拿到选择文件的数组
      	const files = e.target.files
      	//如果没有选择图片
      	if (files.length === 0) {
      		this.addForm.img_url = null
      		//显示原本的图片路径
      		this.$refs.imgRef.setAttribute('src', imgObj)
      	} else {
      		this.addForm.img_url = files[0]
      		//把图片文件，要显示到img标签里，图片转出链接
      		const url = URL.createObjectURL(files[0])
      		//setAttribute指定属性
      		this.$refs.imgRef.setAttribute('src', url)
      	}
      },
      //删除图片
      delCoverFn(){
      	this.addForm.img_url = null
      	this.$refs.imgRef.setAttribute('src', imgObj)
      },
			//点击按钮，添加信息
			addFn(){
				console.log(this.addForm)
			this.$refs.addFormRef.validate(async valid => {
				if (valid) {
					const fd = new FormData() //准备一个表单数据对象的容器
					//fd.append('参数名',值)
					fd.append('name', this.addForm.name)
					fd.append('description', this.addForm.description)
					fd.append('Fid', this.addForm.Fid)
					fd.append('type', this.addForm.type)
          fd.append('img_url', this.addForm.img_url)
          fd.append('size', this.addForm.size)
          console.log(fd)
					const {data: res} = await this.$http.addHomeData({data: fd})
					if (res.status == 1) return this.$message.error('添加信息失败!')
          if (res.status == 2) return this.$message.error('名称被占用，请更换后重试！')
						this.addDialogVisible = false
						this.$message.success('添加信息成功!')
            this.getHomeList()
				} else {
					return false
				}
			})
			},
			//监听添加对话框的关闭
			addDialogClosed(){
				this.$refs.addFormRef.resetFields()
        //显示原本的图片路径
        this.$refs.imgRef.setAttribute('src', imgObj)
				this.Rightlist=[]
			},
			//展示编辑的对话框
			async showEditDialog(id){
				const {data:res} = await this.$http.byIdHome(id)
				if (res.status !==0){
					return this.$message.error('查询信息失败!')
				}
				this.Rightlist.push({
				   typeId:res.data.type,
				   //三目运算符，三个条件写法
				   label:res.data.type==1 ?'一级权限':(res.data.type==2 ? '二级权限':'三级权限')
				})
         this.editForm = res.data
         this.editTp = this.editForm.img_url
				 console.log(this.editForm)
				 this.editDialogVisible = true
			},
      editselCoverFn() {
      	this.$refs.editiptFileRef.click()
      },
      //封面文件
      editchangeCoverFn(e) {
      	const files = e.target.files
      	console.log(files)
      	if (files.length === 0) {
      	} else {
      		this.editForm.img_url = files[0]
      		//把图片文件，要显示到img标签里，图片转出链接
      		const url = URL.createObjectURL(files[0])
      		//setAttribute指定属性
      		this.$refs.editimgRef.setAttribute('src', url)
      		//放大镜
      		this.$refs.big.setAttribute('src', url)
      	}
      },
		//修改信息并提交
		editInfo(){
			this.$refs.editFormRef.validate(async valid =>{
			if (!valid) return
      const fd = new FormData()
     fd.append('id', this.editForm.id)
     fd.append('name', this.editForm.name)
     fd.append('description', this.editForm.description)
     fd.append('Fid', this.editForm.Fid)
     fd.append('type', this.editForm.type)
     fd.append('img_url', this.editForm.img_url)
     fd.append('size', this.editForm.size)
			const {data:res} = await this.$http.updateByHome({data:fd})
			if (res.status == 1) return this.$message.error('修改信息失败!')
			if (res.status == 2) return this.$message.error('名称被占用，请更换后重试！')
			this.$message.success('修改信息成功!')
			this.editDialogVisible = false
		  this.getHomeList()
			 })
		},
		//监听修改对话框的关闭
		editDialogClosed(){
			this.$refs.editFormRef.resetFields()
			this.Rightlist=[]
		},
		//根据Id删除对应信息
		async removeById(id){
			//弹框询问用户是否删除数据
			        const confirmResult = await this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).catch(err => err)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消删除')
					}
					const {data:res} = await this.$http.delHome(id)
					if (res.status !==0){
						return this.$message.error('删除失败!')
					}
					this.$message.success('删除成功!')
					this.getHomeList()
		},
		}
	}
</script>

<style lang="less" scoped>
  // 放大镜效果
  .spec-preview {
  	position: relative;
  	width: 400px;
  	height: 400px;
  	border: 1px solid #ccc;

  	img {
  		width: 100%;
  		height: 100%;
  	}

  	.event {
  		width: 100%;
  		height: 100%;
  		position: absolute;
  		top: 0;
  		left: 0;
  		z-index: 998;
  	}

  	.mask {
  		width: 50%;
  		height: 50%;
  		background-color: rgba(0, 255, 0, 0.3);
  		position: absolute;
  		left: 0;
  		top: 0;
  		display: none;
  	}

  	.big {
  		width: 100%;
  		height: 100%;
  		position: absolute;
  		top: -1px;
  		left: 100%;
  		border: 1px solid #aaa;
  		overflow: hidden;
  		z-index: 998;
  		display: none;
  		background: white;

  		img {
  			width: 200%;
  			max-width: 200%;
  			height: 200%;
  			position: absolute;
  			left: 0;
  			top: 0;
  		}
  	}

  	.event:hover~.mask,
  	.event:hover~.big {
  		display: block;
  	}
  }
</style>
